<cerrix-loader [cerrixTab]="tab"></cerrix-loader>

@if (inviteConfig) {
    <cerrix-invite [inviteConfig]="inviteConfig">
        <ng-template #userTemplate let-user>
            <div class="card" [class.bg-primary]="inviteConfig.userSelection.indexOf(user.ID) >= 0">
                <div class="card-body">
                    <h6 class="card-title">{{ user.displayName }}</h6>
                    <p class="card-text">{{ user.mail }}</p>
                    <p class="card-text">{{ user.organizationName }}</p>
                    @if (user.assignedObjectName) {
                        <p class="card-text text-truncate" [title]="user.assignedObjectName">
                            {{ user.assignedObjectName }}
                        </p>
                    }
                    <p class="card-text">
                        <small class="text-muted">{{ user.invitationStatus }}</small>
                    </p>
                </div>
            </div>
        </ng-template>
    </cerrix-invite>
}

@if (!targetedInvitationType && inviteModel) {
    <div class="invite-type-selection">
        <div class="card">
            <div class="card-body">
                <h5 class="card-title">{{ 'formInvite.requiredInvitationTitle' | t }}</h5>
                <p class="card-subtitle text-muted mb-3">
                    {{ 'formInvite.requiredInvitationDescription' | t }}
                </p>
                <p class="card-subtitle text-muted mb-4">
                    {{ 'formInvite.requiredInvitationTracking' | t }}
                </p>
                <button
                    class="btn btn-outline-primary"
                    (click)="loadType(inviteType.RequiredInvitation)"
                >
                    {{ 'formInvite.selectBtn' | t }}
                </button>
            </div>
        </div>

        <div class="card">
            <div class="card-body">
                <h5 class="card-title">{{ 'formInvite.shareFormTitle' | t }}</h5>
                <p class="card-subtitle text-muted mb-4">
                    {{ 'formInvite.shareFormDescription' | t }}
                </p>
                <button
                    class="btn btn-outline-primary"
                    (click)="loadType(inviteType.ShareInvitation)"
                >
                    {{ 'formInvite.selectBtn' | t }}
                </button>
            </div>
        </div>
    </div>
}
